import { render, staticRenderFns } from "./TheoryExam.vue?vue&type=template&id=fa784804&"
import script from "./TheoryExam.vue?vue&type=script&lang=ts&"
export * from "./TheoryExam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports